import type {
  Filter, LogicGroup, LogicStatement, MaybeHydra,
} from '@/entities/Entities';

export const parseFilter = (filter: MaybeHydra<Filter>): MaybeHydra<Filter> | null => {
  const newFilter = JSON.parse(JSON.stringify(filter));
  newFilter.id = filter['@id'] ?? undefined;
  newFilter.logicGroups = filter.logicGroups.map(
    (group: MaybeHydra<LogicGroup>): MaybeHydra<LogicGroup> => ({
      id: group['@id'] ?? undefined,
      logicStatements: group.logicStatements.map(
        (statement: MaybeHydra<LogicStatement>): MaybeHydra<LogicStatement> => ({
          id: statement['@id'] ?? undefined,
          name: statement.name,
          data: statement.data,
        }),
      ),
    }),
  );
  if (newFilter.logicGroups.length === 0) {
    return null;
  }

  return newFilter;
};
